import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useRoutes,
} from "react-router-dom";
import HomeDataContent from "../components/HomeDataContent/HomeDataContent";
import InstrumentsDetails from "../components/InstrumentsDetails/InstrumentsDetails";
import PortfolioTabs from "../components/PortfolioTabs/PortfolioTabs";
import QuickViewsDetails from "../components/QuickViewsDetails/QuickViewsDetails";
import { Login } from "../pages";
import AboutUs from "../pages/AboutUs/AboutUs";
import Blocked from "../pages/Blocked/Blocked";
import Connect from "../pages/Connect/Connect";
import ConnectPage from "../pages/ConnectPage/ConnectPage";
import Performance from "../pages/Performance/Performance";
import Home from "../pages/Home/Home";
import LinkedClients from "../pages/LinkedClients/LinkedClients";
import NoAccess from "../pages/NoAccess/NoAccess";
import NoInvestment from "../pages/NoInvestment/NoInvestment";
import NoLinkedClients from "../pages/NoLinkedClients/NoLinkedClients";
import NoDataFound from "../pages/NoDataFound/NoDataFound";
import Portfolio from "../pages/Portfolio/Portfolio";
import Profile from "../pages/Profile/Profile";
import SelectFamilies from "../pages/SelectFamilies/SelectFamilies";
import Settings from "../pages/Settings/Settings";
import SettingsMain from "../pages/SettingsMain.js/SettingsMain";
import UnlockAccount from "../pages/UnLockAccount/UnlockAccount";
import UploadProfile from "../pages/UploadProfile";
import Welcome from "../pages/Welcome/Welcome";
import YourTeam from "../pages/YourTeam/YourTeam";
import Analytics from "../pages/Analytics/Analytics";
import PerformanceLevel2 from "../components/PerformanceLevel2/PerformanceLevel2";
import TaxReport from "../pages/Reports/TaxReport";
import TransactionsReport from "../pages/Reports/TransactionsReport";
import TransactionsCorporateActionReport from "../pages/Reports/TransactionsCorporateActionReport";
import PortfolioReport from "../pages/Reports/PortfolioReport";
import UnrealisedGainLossReport from "../pages/Reports/UnrealisedGainLossReport";
import LedgerReport from "../pages/Reports/LedgerReport";
//import MarginStatementReport from "../pages/Reports/MarginStatementReport";
import BillsContractNotes from "../pages/Reports/BillsContractNotes";
import { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import NotFound from "../pages/NotFound/NotFound";
import {
  getDecodedToken,
  getUsersOffshoreValue,
  logout,
} from "../utils/functions";
import OrientationScreenForTab from "../components/OrientationScreen/OrientationScreenForTab";
import OrientationScreenForMobile from "../components/OrientationScreen/OrientationScreenForMobile";
import Reports from "../pages/Reports/Reports";
import TransactionsReportInfinity from "../pages/Reports/TransactionsReportInfinity";
import TransactionsCorporateActionReportInfinity from "../pages/Reports/TransactionsCorporateActionReportInfinity";
import AnalyticsTabs from "../components/Analytics/AnalyticsTabs/AnalyticsTabs";
import { isMobileOnly, isTablet } from "react-device-detect";
import useWindowDimensions from "../utils/useWindowDimensions";
import PerformanceSub from "../components/PerformanceSub/PerformanceSub";
import DownloadFile from "../pages/DownloadFile/DownloadFile";
import { deleteCookie, getCookie, setCookie } from "../utils/cookie";
import DownLoadPortfolioReport from "../components/DownLoadPortfolioReport/DownLoadPortfolioReport";
import SFLogin from "../pages/Login/SFLogin";
import ReportsStore from "../store/ReportsStore";
import UserStore from "../store/UserStore";
import AuthStore from "../store/AuthStore";
import PerformanceStore from "../store/PerformanceStore";
import SettingsStore from "../store/SettingsStore";
import CheckLiasionOfficer from "../components/CheckLiasionOfficer/CheckLiasionOfficer";
import CheckLiasionOfficer2 from "../components/CheckLiasionOfficer2/CheckLiasionOfficer2";
import CheckRoutes from "../components/CheckRoutes/CheckRoutes";
import DirectEquitySummary from "../pages/DirectEquitySummary/DirectEquitySummary";
import InfinityHoldings from "../components/InfinityHoldings/InfinityHoldings";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import PerformanceModuleWrapper from "../pages/Checker2/Checker2";
import { getPerformance } from "firebase/performance";
import DownloadPdf from "../pages/DownloadFile/DownloadPdf";
import { OFFSHORE } from "../utils/constants";
import OffshoreDataSubAssetPage from "../pages/SubAssetPage/OffshoreDataSubAssetPage";

import { useRef } from "react";
import LayoutContext from "../components/Contexts/LayoutContext";
import AllErrorModalUGL from "../components/ModalFamily/AllErrorModalUGL";
import Modal from "../components/Modal";
import { errorModalPadding, homePageRoute } from "../utils/constants";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY_ANALYTICS,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN_ANALYTICS,
  projectId: process.env.REACT_APP_PROJECT_ID_ANALYTICS,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET_ANALYTICS,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID_ANALYTICS,
  appId: process.env.REACT_APP_APP_ID_ANALYTICS,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID_ANALYTICS,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
getPerformance(app);

const AllRoutes = observer(({ isPortrait }) => {
  const dataRef = useRef(null);
  const { width, height } = useWindowDimensions();
  let checkLandscape;
  if (height < width && width > 800) {
    checkLandscape = true;
  } else {
    checkLandscape = false;
  }

  const isLoggedIn = getCookie("token");
  const isSessionId = getCookie("sessionid");
  const [orientation, setOrientation] = useState();
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleOrientationChange = (event) => {
      const { matches, media } = event;
      if (matches) {
        setOrientation(media);
      }
    };

    const mediaQueryPortrait = window.matchMedia("(orientation: portrait)");
    const mediaQueryLandscape = window.matchMedia("(orientation: landscape)");

    if (mediaQueryPortrait.matches) {
      setOrientation("portrait");
    } else if (mediaQueryLandscape.matches) {
      setOrientation("landscape");
    }

    mediaQueryPortrait.addEventListener("change", handleOrientationChange);
    mediaQueryLandscape.addEventListener("change", handleOrientationChange);

    let inactiveTime = setTimeout(
      () => {
        if (UserStore.userData.user_id) {
          AuthStore.setData("isSessionExpired", true);
        }
        // logout({isSessionExpired : true});
        //   navigate("/");
      },
      20 * 60 * 1000,
    );
    // After 20 mins of mount witout any activity, it will open a logout warning modal
    // And after clicking Okay button in this modal or on outside click logged in user will get logged out

    const resetTimeout = () => {
      clearTimeout(inactiveTime);
      inactiveTime = setTimeout(
        () => {
          if (UserStore.userData.user_id) {
            AuthStore.setData("isSessionExpired", true);
          }
          // logout({isSessionExpired : true});
          //   navigate("/");
        },
        20 * 60 * 1000,
      );
    };
    // It will clear the timeout and restart again after user activity

    window.addEventListener("mousemove", resetTimeout);
    window.addEventListener("keydown", resetTimeout);
    return () => {
      window.removeEventListener("mousemove", resetTimeout);
      window.removeEventListener("keydown", resetTimeout);
      clearTimeout(inactiveTime);
    };
    // eslint-disable-next-line
  }, []);

  const pathArr = location.pathname.split("/");
  const urlObj = ReportsStore?.downloadTrigger;

  useEffect(() => {
    // Reports download in new tab
    let count = 0;

    const urls = {
      downloadportfolioReport: true,
      download: true,
      "pdf-file-download": true,
    };

    // from portfolio report page we download file by opening new tab of downloadportfolioReport page and from tax report page we open pdf-file-download page and download page for downloading pdf and excel file
    // so from this page when the downlaod gets completed , we close those newly opened tabs and the file gets downloaded in the original tab
    // We set the download trigger in the store and check here if its present and if yes we download the file and clear the trigger from the store

    if (!urls[pathArr[pathArr.length - 1]] && urlObj.length) {
      const intervalId = setInterval(() => {
        count = count + 1;

        const urlObj = getCookie("url");

        if (urlObj && urlObj?.url && urlObj?.fileName) {
          let anchorEl = document.createElement("a");
          anchorEl.href = urlObj?.url;
          anchorEl.download = `${urlObj?.fileName}`;
          anchorEl.click();
          anchorEl.remove();
          setCookie("url", undefined);

          let arr = ReportsStore.downloadTrigger;
          arr.splice(0, 1);
          ReportsStore.setDownloadTrigger([...arr]);
          if (arr === 0) {
            deleteCookie("url");
            clearInterval(intervalId);
          }
        }

        if (count === 300) {
          ReportsStore.setDownloadTrigger([]);
          deleteCookie("url");
          clearInterval(intervalId);
        }
      }, 1000); // Check every second
      return () => clearInterval(intervalId);
    }
    // eslint-disable-next-line
  }, [urlObj]);

  useEffect(() => {
    if (
      UserStore.isHydrated &&
      PerformanceStore.isHydrated &&
      SettingsStore.isHydrated
    ) {
      if (getCookie("token")) {
        const { user_type } = getDecodedToken();
        if (!UserStore.userData.user_id) {
          AuthStore.updateLoadingFullScreen(true);
          const user_type = getDecodedToken()?.user_type;
          if (user_type === "employee") navigate("selectfamilies");
          else if (user_type === "manager") navigate("linkedclients");
        } else if (user_type === "manager") {
          UserStore.getLiaisonsData();
        }
      }
    }
    // eslint-disable-next-line
  }, [
    UserStore.isHydrated,
    PerformanceStore.isHydrated,
    SettingsStore.isHydrated,
  ]);

  useEffect(() => {
    if (AuthStore.isSessionExpired || AuthStore.isSessionExpiredFromAPI) {
      setIsWarningModalOpen(true);
    }
  }, [AuthStore.isSessionExpired, AuthStore.isSessionExpiredFromAPI]);

  const element = useRoutes([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "sflogin",
      element: <SFLogin />,
    },

    {
      path: "/login/:type",
      element: <Login />,
    },
    {
      path: "/welcome",
      element: isLoggedIn ? (
        <CheckRoutes>
          <Welcome />{" "}
        </CheckRoutes>
      ) : (
        <Navigate to="/not-found" />
      ),
    },
    {
      path: "/aboutus",
      element: isLoggedIn ? (
        <CheckRoutes>
          <AboutUs />{" "}
        </CheckRoutes>
      ) : (
        <Navigate to="/not-found" />
      ),
    },
    {
      path: "/upload",
      element: isLoggedIn ? (
        <CheckRoutes>
          <UploadProfile />{" "}
        </CheckRoutes>
      ) : (
        <Navigate to="/not-found" />
      ),
    },
    {
      path: "/linkedclients",
      element: isLoggedIn ? (
        <CheckRoutes>
          <LinkedClients />{" "}
        </CheckRoutes>
      ) : (
        <Navigate to="/not-found" />
      ),
    },
    {
      path: "/selectfamilies",
      element: isLoggedIn ? (
        <CheckRoutes>
          <SelectFamilies />
        </CheckRoutes>
      ) : (
        <Navigate to="/not-found" />
      ),
    },
    {
      path: "/nolinkedclients",
      element: isLoggedIn ? (
        <CheckRoutes>
          <NoLinkedClients />
        </CheckRoutes>
      ) : (
        <Navigate to="/not-found" />
      ),
    },
    {
      path: "/unlockaccount",
      element: isLoggedIn ? (
        <CheckRoutes>
          <UnlockAccount />
        </CheckRoutes>
      ) : (
        <Navigate to="/not-found" />
      ),
    },

    {
      path: "/blocked",
      element: isSessionId ? <Blocked /> : <Navigate to="/not-found" />,
    },
    {
      path: "/noinvestment",
      element: isLoggedIn ? <NoInvestment /> : <Navigate to="/not-found" />,
    },
    {
      path: "/no-data-found",
      element: isLoggedIn ? <NoDataFound /> : <Navigate to="/not-found" />,
    },
    {
      path: "/analytics",
      element: isLoggedIn ? <Analytics /> : <Navigate to="/not-found" />,
      children: [{ index: true, element: <AnalyticsTabs /> }],
    },
    {
      path: `/${homePageRoute}`,
      element:
        isLoggedIn && getUsersOffshoreValue({}) !== OFFSHORE ? (
          <Home />
        ) : (
          <Navigate to="/not-found" />
        ),
      children: [
        { index: true, element: <HomeDataContent /> },
        {
          path: "instrument/infinity/:instrumentId",
          element: <InfinityHoldings />,
        },
        {
          path: "subassetclassdetailshome/:assetClassId/:vehicleId",
          element: <DirectEquitySummary />,
        },
        {
          path: "subassetclassdetailsinfiniity/:assetClassId/:vehicleId/:lastMeasureId",
          element: <DirectEquitySummary />,
        },
      ],
    },
    {
      path: "/portfolio",
      element: isLoggedIn ? <Portfolio /> : <Navigate to="/not-found" />,
      children: [
        { index: true, element: <PortfolioTabs /> },
        {
          path: "quickDetails/:dataId/:instuType",
          element: <QuickViewsDetails />,
        },
        {
          path: "instrument/infinity/:instrumentId",
          element: <InfinityHoldings />,
        },
        {
          path: "instrument_portfolio/infinity/:instrumentId",
          element: <InfinityHoldings />,
        },
        {
          path: "subassetclassdetails_portfolio/:assetClassId/:vehicleId",
          element: <DirectEquitySummary />,
        },
        {
          path: "subassetclassdetailsQuick/:assetClassId/:vehicleId",
          element: <DirectEquitySummary />,
        },
        {
          path: "subassetclassdetailsinfiniity/:assetClassId/:vehicleId/:lastMeasureId",
          element: <DirectEquitySummary />,
        },
        {
          path: "subassetclassdetailsinfiniity_portfolio/:assetClassId/:vehicleId/:lastMeasureId",
          element: <DirectEquitySummary />,
        },
        {
          path: "global-sub-asset-class/:assetClassId/:vehicleId",
          element: <OffshoreDataSubAssetPage />,
        },
      ],
    },
    {
      path: "/connect",
      element: isLoggedIn ? <ConnectPage /> : <Navigate to="/not-found" />,
      children: [
        { index: true, element: <Connect /> },
        { path: "yourteam", element: <YourTeam /> },
      ],
    },
    {
      path: "/settings",
      element: isLoggedIn ? <SettingsMain /> : <Navigate to="/not-found" />,
      children: [
        { index: true, element: <Settings /> },
        { path: "add-family-office-team", element: <CheckLiasionOfficer2 /> },
        { path: "edit-family-office-team", element: <CheckLiasionOfficer /> },
      ],
    },
    {
      path: "/noaccess",
      element: <NoAccess />,
    },
    {
      path: "/profile",
      element: isLoggedIn ? <Profile /> : <Navigate to="/not-found" />,
    },

    {
      path: "*",
      element: <Navigate to="/not-found" />,
    },
    {
      path: "/*",
      element: <Navigate to="/not-found" />,
    },
    {
      path: "/not-found",
      element: <NotFound />,
    },
    {
      path: "performance",
      element: isLoggedIn ? (
        <PerformanceModuleWrapper />
      ) : (
        <Navigate to="/not-found" />
      ),
      children: [
        {
          path: ":performanceRoute1",
          element: <Performance />,
          children: [{ index: true, element: <PerformanceSub /> }],
        },
        {
          path: ":performanceRoute1/:performanceRoute2/:performanceRoute3/:performanceRoute4",
          element: isLoggedIn ? (
            <div>
              {" "}
              <InstrumentsDetails />{" "}
            </div>
          ) : (
            <Navigate to="/not-found" />
          ),
        },
        {
          path: ":performanceRoute1/:performanceRoute2",
          element: isLoggedIn ? (
            <div>
              {" "}
              <PerformanceLevel2 />{" "}
            </div>
          ) : (
            <Navigate to="/not-found" />
          ),
        },
      ],
    },
    {
      path: "/reports",
      element: isLoggedIn ? <Reports /> : <Navigate to="/not-found" />,
      children: [
        {
          path: "download",
          element: <DownloadFile />,
        },
        {
          path: "downloadportfolioReport",
          element: <DownLoadPortfolioReport />,
        },
        { path: "transactions-report", element: <TransactionsReport /> },
        {
          path: "infinity-transactions-report",
          element: <TransactionsReportInfinity />,
        },
        {
          path: "transactions-corporate-action-report",
          element: <TransactionsCorporateActionReport />,
        },
        {
          path: "infinity-transactions-corporate-action-report",
          element: <TransactionsCorporateActionReportInfinity />,
        },
        { path: "portfolio-report", element: <PortfolioReport /> },
        {
          path: "tax-report",
          element: <div>{<Outlet />}</div>,
          children: [
            {
              index: true,
              element: <TaxReport />,
            },
            {
              path: "pdf-file-download",
              element: <DownloadPdf />,
            },
          ],
        },
        {
          path: "unrealised-gain-loss-report",
          element: <UnrealisedGainLossReport />,
        },
        { path: "ledger-report", element: <LedgerReport /> },
        // { path: "margin-statement-report", element: <MarginStatementReport /> },
        { path: "bills-and-contract-notes", element: <BillsContractNotes /> },
      ],
    },
    {
      path: "/download",
      element: <DownloadFile />,
    },
  ]);
  return (
    <>
      <div className="app">
        <div
          role="status"
          aria-live="polite"
          aria-atomic="true"
          className="sr-only"
          style={{ display: "none" }}
        >
          {AuthStore.isSessionExpired || AuthStore.isSessionExpiredFromAPI
            ? "Session has expired. Kindly relogin."
            : ""}
        </div>
        <LayoutContext.Provider value={{ dataRef }}>
          <div style={{ visibility: "" }} ref={dataRef}>
            {isMobileOnly && !isTablet ? (
              <OrientationScreenForMobile isLandScape={height < width} />
            ) : isTablet &&
              (orientation === "(orientation: portrait)" ||
                orientation === "portrait") ? (
              <div
                className={`tablet-view ${
                  checkLandscape ? "landscape" : "portrait"
                }`}
              >
                <OrientationScreenForTab />
              </div>
            ) : (
              element
            )}
          </div>
        </LayoutContext.Provider>
      </div>
      {isWarningModalOpen && (
        <Modal
          onClose={() => {
            if (AuthStore.isSessionExpiredFromAPI) {
              AuthStore.setData("isSessionExpiredFromAPI", false);
            } else {
              AuthStore.setData("isSessionExpired", false);
            }
            setIsWarningModalOpen(false);
            logout();
            navigate("/");
          }}
          open={AuthStore.isSessionExpired || AuthStore.isSessionExpiredFromAPI}
          modalStyle={errorModalPadding}
          showCloseIcon={false}
          announcement={"logout-warning"}
          modalWrapperClass={"logout-modal"}
        >
          <AllErrorModalUGL
            msg={"Session Has Expired. Kindly relogin"}
            confirmationButtonName={"Okay"}
            onConfirm={() => {
              if (AuthStore.isSessionExpiredFromAPI) {
                AuthStore.setData("isSessionExpiredFromAPI", false);
              } else {
                AuthStore.setData("isSessionExpired", false);
              }
              setIsWarningModalOpen(false);
              logout();
              navigate("/");
            }}
            containerClassName={"logout-alert-modal"}
          />
        </Modal>
      )}
    </>
  );
});

export default AllRoutes;
